
import { BlogCategory } from "./BlogCategory";

export const blogCategories: BlogCategory[] = [
  {
    name: "Cybersecurity",
    slug: "cybersecurity",
    description: "Insights and tips on how to protect your business from cyber threats."
  },
  {
    name: "Cloud Solutions",
    slug: "cloud-solutions",
    description: "Expert advice on leveraging cloud technology to improve efficiency and reduce costs."
  },
  {
    name: "Managed IT",
    slug: "managed-it",
    description: "Learn how managed IT services can help your business stay competitive and secure."
  },
  {
    name: "Business Strategy",
    slug: "business-strategy",
    description: "Strategies and insights to align your IT with your business goals."
  },
  {
    name: "Healthcare IT",
    slug: "healthcare-it",
    description: "Guidance on navigating the unique IT challenges of the healthcare industry."
  },
  {
    name: "Financial Services IT",
    slug: "financial-services-it",
    description: "Solutions for securing sensitive financial data and meeting regulatory requirements."
  },
  {
    name: "Industry Solutions",
    slug: "industry-solutions",
    description: "Tailored IT solutions for specific industries, from real estate to manufacturing."
  },
  {
    name: "Network Security",
    slug: "network-security",
    description: "Best practices for securing your network infrastructure and protecting against cyber threats."
  },
  {
    name: "Business Continuity",
    slug: "business-continuity",
    description: "Strategies for ensuring your business can continue operating in the event of a disaster."
  },
  {
    name: "Property Management",
    slug: "property-management",
    description: "IT solutions for property managers and landlords to streamline operations and protect tenant data."
  },
  {
    name: "Partnership",
    slug: "partnership",
    description: "Announcements of partnerships"
  }
];

// Blog schema for SEO
export const blogSchema = {
  "@context": "https://schema.org",
  "@type": "Blog",
  "name": "IT Management Solutions Blog",
  "description": "Expert insights on IT management, cybersecurity, and technology solutions for businesses."
};

// Categories for filtering with icons
export const categories = [
  { id: "all", name: "All Posts", description: "All blog posts", icon: null },
  { id: "cybersecurity", name: "Cybersecurity", description: "Security insights and best practices", icon: "Shield" },
  { id: "cloud-solutions", name: "Cloud Solutions", description: "Cloud technology guidance", icon: "Cloud" },
  { id: "managed-it", name: "Managed IT", description: "IT management services", icon: "Wrench" },
  { id: "business-strategy", name: "Business Strategy", description: "Technology strategy alignment", icon: "Briefcase" },
  { id: "healthcare-it", name: "Healthcare IT", description: "Healthcare technology solutions", icon: "Building" },
  { id: "financial-services-it", name: "Financial Services IT", description: "Financial sector IT solutions", icon: "Briefcase" },
  { id: "industry-specific", name: "Industry Solutions", description: "Industry-specific solutions", icon: "Building" },
  { id: "network-security", name: "Network Security", description: "Network protection strategies", icon: "Shield" },
  { id: "business-continuity", name: "Business Continuity", description: "Disaster recovery and continuity", icon: "Briefcase" },
  { id: "property-management", name: "Property Management", description: "Property management IT", icon: "Building" },
  { id: "partnership", name: "Partnerships", description: "Partnership announcements", icon: "Briefcase" }
];

// Industry subcategories with parentId
export const industrySubcategories = [
  { id: "real-estate", name: "Real Estate", description: "Real estate technology solutions", parentId: "industry-specific" },
  { id: "healthcare", name: "Healthcare", description: "Healthcare IT solutions", parentId: "industry-specific" },
  { id: "financial", name: "Financial Services", description: "Financial sector solutions", parentId: "industry-specific" },
  { id: "property-mgmt", name: "Property Management", description: "Property management solutions", parentId: "industry-specific" }
];

// Popular topics
export const popularTopics = [
  "Cybersecurity",
  "Cloud Migration",
  "HIPAA Compliance",
  "Zero Trust Security",
  "Business Continuity",
  "IT Support"
];

export const blogPosts = [
  {
    id: 12,
    title: "Streamlined Cybersecurity Compliance: IT Management Solutions Partners with Vanta",
    slug: "vanta-partnership-cybersecurity-compliance-ny-nj",
    excerpt: "Discover how our strategic partnership with Vanta transforms cybersecurity compliance for small and mid-sized businesses across New York and New Jersey.",
    content: "We're excited to announce our partnership with Vanta to provide automated cybersecurity compliance solutions...",
    author: "Adam Gross",
    authorTitle: "CEO & Founder",
    date: "June 26, 2025",
    readTime: "14 min read",
    category: "partnership",
    tags: ["vanta", "compliance", "cybersecurity", "partnership", "automation"],
    image: "/lovable-uploads/ec57ccd2-fd46-4b4a-9b95-bc3fe17ab678.png"
  },
  {
    id: 11,
    title: "Cybersecurity for Landlords and Property Managers: How to Level Up Your Security Game",
    slug: "cybersecurity-landlords-property-managers-level-up",
    excerpt: "Property managers and landlords face unique cybersecurity challenges. Learn how to protect tenant data and property management systems.",
    content: "Property management involves handling sensitive tenant information...",
    author: "Adam Gross",
    authorTitle: "CEO & Founder",
    date: "June 19, 2025",
    readTime: "10 min read",
    category: "property-management",
    tags: ["property management", "cybersecurity", "tenant data", "compliance"],
    image: "https://images.unsplash.com/photo-1531297484001-80022131f5a1?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80"
  },
  {
    id: 10,
    title: "Disaster Recovery and Business Continuity Planning: A Small Business Framework",
    slug: "disaster-recovery-business-continuity-planning-smb-framework",
    excerpt: "Build a comprehensive disaster recovery plan that keeps your small business running when the unexpected happens.",
    content: "Every business needs a solid disaster recovery plan...",
    author: "Adam Gross",
    authorTitle: "CEO & Founder",
    date: "June 12, 2025",
    readTime: "16 min read",
    category: "business-continuity",
    tags: ["disaster recovery", "business continuity", "planning", "resilience"],
    image: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80"
  },
  {
    id: 9,
    title: "Network Segmentation for Small Business: A Practical Security Guide",
    slug: "network-segmentation-small-business",
    excerpt: "Implement network segmentation to enhance your small business security posture and protect critical assets from cyber threats.",
    content: "Network segmentation is a critical security practice...",
    author: "Adam Gross",
    authorTitle: "CEO & Founder",
    date: "May 29, 2025",
    readTime: "12 min read",
    category: "network-security",
    tags: ["network segmentation", "security", "infrastructure", "protection"],
    image: "https://images.unsplash.com/photo-1531297484001-80022131f5a1?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80"
  },
  {
    id: 8,
    title: "Why Zero-Trust Security is Non-Negotiable for Small Businesses in 2024",
    slug: "zero-trust-security-small-businesses",
    excerpt: "Learn why Zero-Trust security architecture is essential for protecting your small business from modern cyber threats and data breaches.",
    content: "Traditional security models are no longer sufficient...",
    author: "Adam Gross",
    authorTitle: "CEO & Founder",
    date: "May 22, 2025",
    readTime: "14 min read",
    category: "cybersecurity",
    tags: ["zero-trust", "cybersecurity", "small business", "architecture"],
    image: "https://images.unsplash.com/photo-1531297484001-80022131f5a1?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80"
  },
  {
    id: 1,
    title: "5 Cybersecurity Best Practices Every Small Business Should Implement",
    slug: "cybersecurity-best-practices-small-business",
    excerpt: "Protect your business from cyber threats with these essential security practices that every small business owner should know and implement.",
    content: "Learn the fundamental cybersecurity practices that can protect your business from common threats...",
    author: "Adam Gross",
    authorTitle: "CEO & Founder",
    date: "May 15, 2025",
    readTime: "8 min read",
    category: "cybersecurity",
    tags: ["cybersecurity", "small business", "security"],
    image: "https://images.unsplash.com/photo-1531297484001-80022131f5a1?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80"
  },
  {
    id: 2,
    title: "Cloud Migration Guide for Small Businesses: Making the Move Safely",
    slug: "cloud-migration-guide-small-businesses",
    excerpt: "A comprehensive guide to migrating your business to the cloud safely and efficiently, with practical tips and best practices.",
    content: "Moving to the cloud can transform your business operations...",
    author: "Adam Gross",
    authorTitle: "CEO & Founder",
    date: "May 8, 2025",
    readTime: "12 min read",
    category: "cloud-solutions",
    tags: ["cloud", "migration", "small business"],
    image: "https://images.unsplash.com/photo-1544197150-b99a580bb7a8?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80"
  },
  {
    id: 3,
    title: "The Hidden Cost of IT Downtime: Why Prevention is Your Best Investment",
    slug: "cost-of-it-downtime-prevention",
    excerpt: "Discover the true cost of IT downtime for small businesses and learn how proactive IT management can save you thousands.",
    content: "IT downtime costs small businesses more than they realize...",
    author: "Adam Gross",
    authorTitle: "CEO & Founder",
    date: "May 1, 2025",
    readTime: "10 min read",
    category: "managed-it",
    tags: ["downtime", "business continuity", "ROI"],
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80"
  },
  {
    id: 4,
    title: "Choosing the Right IT Support Model for Business Growth",
    slug: "choosing-it-support-model-business-growth",
    excerpt: "Learn how to select the perfect IT support model that scales with your business growth and maximizes your technology investment.",
    content: "As your business grows, your IT needs evolve...",
    author: "Adam Gross",
    authorTitle: "CEO & Founder",
    date: "April 24, 2025",
    readTime: "9 min read",
    category: "business-strategy",
    tags: ["IT support", "business growth", "strategy"],
    image: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80"
  },
  {
    id: 5,
    title: "HIPAA Compliance IT Requirements: A Healthcare Provider's Complete Guide",
    slug: "hipaa-compliance-it-requirements-healthcare",
    excerpt: "Navigate HIPAA compliance with confidence. A comprehensive guide to IT requirements, best practices, and solutions for healthcare providers.",
    content: "Healthcare providers face unique IT challenges when it comes to HIPAA compliance...",
    author: "Adam Gross",
    authorTitle: "CEO & Founder",
    date: "April 18, 2025",
    readTime: "15 min read",
    category: "healthcare-it",
    tags: ["HIPAA", "healthcare", "compliance", "security"],
    image: "https://images.unsplash.com/photo-1576091160550-2173dba999ef?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80"
  },
  {
    id: 6,
    title: "Secure Document Management Solutions for CPA Firms and Accounting Practices",
    slug: "secure-document-management-cpa-firms",
    excerpt: "Protect sensitive financial data with enterprise-grade document management solutions designed specifically for accounting professionals.",
    content: "CPA firms handle some of the most sensitive financial information...",
    author: "Adam Gross",
    authorTitle: "CEO & Founder",
    date: "April 11, 2025",
    readTime: "11 min read",
    category: "financial-services-it",
    tags: ["document management", "CPA", "security", "compliance"],
    image: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80"
  },
  {
    id: 7,
    title: "Technology Solutions for Real Estate Agencies: Streamlining Operations in a Digital World",
    slug: "technology-solutions-real-estate-agencies",
    excerpt: "Discover how modern technology solutions can transform real estate operations, from client management to transaction processing.",
    content: "The real estate industry is rapidly embracing digital transformation...",
    author: "Adam Gross",
    authorTitle: "CEO & Founder",
    date: "April 4, 2025",
    readTime: "13 min read",
    category: "industry-specific",
    industrySubcategory: "real-estate",
    tags: ["real estate", "CRM", "digital transformation", "automation"],
    image: "https://images.unsplash.com/photo-1560518883-ce09059eeffa?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80"
  }
];

export type { BlogCategory };
